import React from "react";
import { Container, Row } from "react-bootstrap";
import "../styles/Footer.css"
import { Link } from "react-router-dom";



const Footer = () => {
  const containerStyle={
    background:'RGB(161,27,42)',
  }
  const cStyle = {
    maxWidth: '800px',
  }
  const phoneNumber = '77077542535';
    return(
       <>
       <div style={containerStyle}>
    <Container style={cStyle}>
  <div className="py-1">
    <Row>
    
    <div >
    
      <nav style={{ textAlign: 'left' }}>
        <ul style={{ listStyleType: 'none', margin: 0, padding: 0}} >
          <li style={{ margin: '0 1rem', display: 'inline-block' }}><h5 style={{ color: 'white' }}>COTTO</h5></li>
          <li style={{ margin: '0 1rem', display: 'inline-block' }} ><Link to={'/'} className="text-light">Главная</Link></li>
          <li style={{ margin: '0 1rem', display: 'inline-block' }}><Link to={"/about"} className="text-light">О нас</Link></li>
          <li style={{ margin: '0 1rem', display: 'inline-block' }}><Link to={"/galery"} className="text-light">Галерея</Link></li>
          <li style={{ margin: '0 1rem', display: 'inline-block' }}><Link to={"/contact"} className="text-light">Контакты</Link></li>
        </ul>
        </nav>
      </div>
      
    <div className="d-flex flex-column flex-sm-row justify-content-between py-1 my-1 border-top">
      <p style={{ color: 'white' }}>© 2023 Kromsan, Inc. All rights reserved.</p>
  </div>
  </Row>
  </div>
</Container>
</div>
       </>
    )
}


export default Footer